const r = (e, a = !1) => e ? a ? e.querySelectorAll('*[tabindex="-1"]') : e.querySelectorAll(`a[href]:not([tabindex="-1"]),
                                     area[href],
                                     input:not([disabled]),
                                     select:not([disabled]),
                                     textarea:not([disabled]),
                                     button:not([disabled]),
                                     iframe,
                                     object,
                                     embed,
                                     *[tabindex]:not([tabindex="-1"]),
                                     *[contenteditable]`) : null;
let n = (e) => {
};
const l = (e, { value: a = !0 }) => {
  if (a) {
    let o = r(e), s = r(e, !0);
    o && o.length > 0 && (n = (t) => {
      o = r(e), s = r(e, !0);
      const i = o[0], f = o[o.length - 1];
      t.target === i && t.shiftKey && t.key === "Tab" ? (t.preventDefault(), f.focus()) : (t.target === f || Array.from(s).indexOf(t.target) >= 0) && !t.shiftKey && t.key === "Tab" && (t.preventDefault(), i.focus());
    }, e.addEventListener("keydown", n));
  }
}, u = (e) => {
  e.removeEventListener("keydown", n);
}, d = {
  beforeMount: l,
  unmounted: u
};
export {
  d as default
};
